import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Lottie from 'lottie-react';
import cubeLoader from '../resources/lottie/cube-loader.json';

// Default loading animation (brand-blue cube). Use this instead of react-loader-spinner
// Oval for any full-page or section-level loading state.
export const CubeLoader = ({ size = 140 }) => (
  <Lottie animationData={cubeLoader} loop autoplay style={{ width: size, height: size }} />
);

const LoadingSpinnerPage = () => {
  const location = useLocation();
  const [message, setMessage] = useState('Loading...');

  useEffect(() => {
    if (location.state?.message) {
      setMessage(location.state.message);
    }
  }, [location.state]);

  return (
  <div className="flex justify-center items-center min-h-screen bg-white">
    <div className="text-center">
      <div className="flex justify-center mb-1">
        <CubeLoader />
      </div>
      <p className="text-gray-700 font-medium text-lg">{message}</p>
    </div>
  </div>
);
};

export default LoadingSpinnerPage;
